export interface RequestResponse<T> {
  data: T;
}

export type RequestPayload<T> = T;
